import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';

/**
 * Reemplaza la vieja pantalla de inicio (InicioScreen): tras el login, cada
 * rol aterriza directo en su seccion. Sin roles (cuenta sin alta), va al
 * perfil, que muestra el aviso correspondiente.
 */
export function InicioRedirect() {
  const { tieneRol } = useAuth();

  if (tieneRol('admin')) return <Navigate to="/admin" replace />;
  if (tieneRol('asesor', 'staff')) return <Navigate to="/panel" replace />;
  return <Navigate to="/perfil" replace />;
}
